import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {GrantApplicationService} from "../../../../services/grantApplication.service";

import {GrantApplicationTaskResponse} from "../../../../models/grantApplication/grantapplicationtaskResponse";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import swal from "sweetalert2";
import {concatMap, Observable, take, takeWhile, timer} from "rxjs";
import {finalize, tap} from "rxjs/operators";
import {SignStatus} from "../../../../models/grantApplication/generatePSASigningLinkRequest";
import {BaseModel, WarningBaseModel} from "../../../../models/BaseModel";
import {ApplicationFileInfo} from "../../../../models/grantApplication/grantApplicationResponse";
import {GrantApplicationStatus} from "../application-detail.component";

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss'],
})
export class TasksComponent implements OnInit, OnDestroy {
  tasks: GrantApplicationTaskResponse[] = [];
  @Input() applicationId: string = "";
  @Input() isReadOnly: boolean = false;
  formModal: BsModalRef | undefined;

  pdfModalRef: BsModalRef | undefined;

  @ViewChild('newPdfModal') newPdfModal!: TemplateRef<any>;


  customerAcceptAgreement: boolean = false;


  downloadPdfSrc = "";

  id: string = '';
  cocPdfSrc: string = '../../../../../assets/document/NHC Code of Conduct – Partners.pdf';
  termPdfSrc: string = '../../../../../assets/document/Terms and Conditions of Project Support.pdf';
  @ViewChild('downloadSignedDocumentTemplate', {static: true}) downloadDocumentTemplate!: TemplateRef<any>;
  @ViewChild('signDocumentTemplate', {static: true}) signDocumentTemplate!: TemplateRef<any>;
  @ViewChild('loadingTemplate', {static: true}) loadingTemplate!: TemplateRef<any>;
  protected selectedApplication: GrantApplicationTaskResponse | undefined;
  protected docStatus: SignStatus | undefined = undefined;
  private SignUrl: string | undefined;
  private signTask: GrantApplicationTaskResponse | undefined;
  private loadingCheckDocStatus: boolean = false;
  private sidCookiesName = 'sidValue';
  @Input() graintApplicationStaus!: GrantApplicationStatus;

  constructor(
    private spinner: NgxSpinnerService,
    private grantApplication: GrantApplicationService,
    private modalService: BsModalService
  ) {

  }

  openPdfModal(template: TemplateRef<any>, application: GrantApplicationTaskResponse): void {
    this.selectedApplication = application;
    this.pdfModalRef = this.modalService.show(template, {
      class: 'modal-lg',
      initialState: {
        modal: this.pdfModalRef,
      },
    });
  }

  async performActionOnModalOk(selectedApplication: GrantApplicationTaskResponse | undefined) {
    if (this.selectedApplication) {

      const result = await this.completeTask(selectedApplication);

      if (result.success) {
        this.selectedApplication.status = 'Complete';
        this.selectedApplication.requireAction = false;
        this.downloadPdf();
      } else {
        await swal.fire({
          title: 'Error',
          text: result.message || 'Failed to complete the task. Please try again later.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    }
  }

  shouldShowSignButton(application: GrantApplicationTaskResponse): boolean {
    const name = application.name?.trim().toLowerCase();
    const result1 = application.requireAction && name === 'signed project support Agreement Contract'.toLowerCase();

    return result1 && !this.loadingCheckDocStatus;
  }

  shouldShowReadAndCoCAgreeButton(application: GrantApplicationTaskResponse) {
    return this.cocTermLogic(application);
  }

  shouldShowReadAndAgreeButton(application: GrantApplicationTaskResponse): boolean {
    return this.termLogic(application);
  }

  async ngOnInit(): Promise<void> {

    const referrer = document.referrer;

    if (this.graintApplicationStaus === 'Approved' || this.isReadOnly) {
      await this.spinner.show();
      this.loadTasks(this.applicationId)
        .finally(() => {
          this.spinner.hide();

          const result = referrer.includes('verified');

          if (result) {

            const sidValue = this.getCookie(this.sidCookiesName);
            if ( sidValue) {

              this.loadPSAStatus(sidValue, this.signTask);

            }

          }


        });
    }


  }

  async getSignUrl() {

    const currentUrl = window.location.href;

    await this.spinner.show();
    this.grantApplication.GeneratePSALink({
      applicationId: this.applicationId,
      redirectUrl: currentUrl
    }).subscribe({
      next: async res => {
        if (res.item) {
          if (res.item.signingLink) {

            this.SignUrl = res.item.signingLink;


            const match = this.SignUrl.match(/sid%3D(.*?)&/);

            if (match && match[1]) {
              const sidValue = match[1];

              this.setCookie(this.sidCookiesName, sidValue, 1);

              if (this.SignUrl) {

                window.location.href = this.SignUrl;
              } else {

              }
              console.log(sidValue);
            } else {
              console.log("No matching value found");
            }
          }
        }
      },
      complete: async () => {
        await this.spinner.hide();
        if (!this.SignUrl) {
          await swal.fire({
            title: 'Signing document',
            text: 'This contract does not have a document for signing.',
            icon: 'error',
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.deleteCookie(this.sidCookiesName);
  }

  async redirectToSignUrl() {

    if (this.signTask?.requireAction) {
      await this.getSignUrl();
    }

  }

  downloadPdf(): void {
    if (this.downloadPdfSrc) {
      const link = document.createElement('a');
      link.href = this.downloadPdfSrc;
      link.download = `${this.selectedApplication?.name || this.selectedApplication?.name}.pdf`;
      link.target = '_blank';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('PDF source not available.');
    }
  }

  loadTasks(appId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.grantApplication.getTasks(appId).subscribe({
        next: async (response) => {
          this.tasks = response.item ?? [];

          this.signTask = this.tasks.find(task => task.name.trim().toLowerCase() === 'signed project support Agreement Contract'.toLowerCase());

          resolve();
        },
        error: (error) => {
          console.error('Error fetching tasks:', error);
          reject(error);
        },
      });
    });
  }

  loadPSAStatus(sidValue: string | undefined, signTask: GrantApplicationTaskResponse | undefined): void {
    if (!sidValue || !signTask?.requireAction) {
      return;
    }

    const polling$ = timer(0, 5000).pipe(
      concatMap(() => {
        this.loadingCheckDocStatus = true;
       return  this.grantApplication.getDocsStatus(sidValue)
      }),
      tap(response => {
        this.docStatus = response.item?.signedStatus;
        if (this.docStatus === 1) {
          signTask.requireAction = false;
          signTask.status = 'Signed';
        } else if (this.docStatus === 2) {
          signTask.requireAction = false;
          signTask.status = 'Rejected';
        }
      }),
      takeWhile(() => this.docStatus === undefined && this.docStatus === 0, true),
      take(10)
    );

    polling$.subscribe({
      next: () => {
        console.log('Polling iteration complete. docStatus:', this.docStatus);
      },
      error: err => {
        console.error('Polling error:', err);
      },
      complete: () => {
        this.loadingCheckDocStatus = false;
        console.log('Polling stopped (docStatus is 1 or 2).');
      },
    });
  }

  getPdfSrc(selectedApplication: GrantApplicationTaskResponse | undefined): string {

    if (!selectedApplication) {
      return "";
    }

    if (this.cocTermLogic(selectedApplication)) {
      this.downloadPdfSrc = this.cocPdfSrc;
      return this.cocPdfSrc;
    }

    this.downloadPdfSrc = this.termPdfSrc;

    return this.termPdfSrc;

  }

  getButtonTemplate(application: GrantApplicationTaskResponse): TemplateRef<any> | null {

    if (application.name.trim().toLowerCase() === 'signed project support Agreement Contract'.toLowerCase()) {
      if (this.signTask?.status === 'Complete') {
        return this.downloadDocumentTemplate;
      }

      if (this.shouldShowSignButton(application)) {
        return this.signDocumentTemplate;
      }

      if (this.loadingCheckDocStatus && application.requireAction
        && application.name.trim().toLowerCase() === 'signed project support Agreement Contract'.toLowerCase()) {
        return this.loadingTemplate;
      }
    }

    return null;

  }

  async downloadPsa() {
    await this.spinner.show();
    this.grantApplication.getSignedDocuments(this.applicationId).pipe(
      concatMap((value) => {

        console.log('PSA file name fetched successfully:', value);

        const fileId = value.item?.fileId || '';

        this.spinner.hide();

        if (!fileId) {
          throw new Error('File ID is missing or invalid.');
        }
        return this.grantApplication.downloadPSAFile(fileId);
      })
    ).subscribe({
      next: (async (fileInfo: BaseModel<ApplicationFileInfo>) => {

        if (fileInfo) {
          let base64Data = fileInfo.item?.documentBody ?? "";
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {type: fileInfo.item?.mimeType});
          await this.spinner.hide();
          // Create download URL
          const url = window.URL.createObjectURL(blob);
          //this.downloadUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = fileInfo.item?.fileName || 'downloaded-file'; // Use the document name if available
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } else {
          await this.spinner.hide();
        }
      }),
      error: async (error) => {
        // Reported by HttpErrorInterceptor, which has the readable text and the reference id.
        // The raw HttpErrorResponse.message that used to be shown here ("Http failure response
        // for <url>: 500") told the user nothing.
        console.error('Error in chained API calls:', error);
      },
      complete: async () => {
        console.log('Finished chained API calls.');
        await this.spinner.hide();
      }
    });
  }

  private setCookie(name: string, value: string, days: number): void {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
  }

  private deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
  }

  private getCookie(name: string): string | null {
    const cookieArr = document.cookie.split(';');
    for (const cookie of cookieArr) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  }

  private cocTermLogic(application: GrantApplicationTaskResponse | undefined) {
    if (!application) {
      return false;
    }
    const name = application.name?.trim().toLowerCase();
    return application.requireAction && name === 'Signed NHC Code of Conduct'.toLowerCase();
  }

  private termLogic(application: GrantApplicationTaskResponse) {
    const name = application.name?.trim().toLowerCase();
    return application.requireAction && name === 'read and agreed to terms and conditions';
  }

  private completeTask(selectedApplication: GrantApplicationTaskResponse | undefined): Promise<{success: boolean, message: string}> {
    if (!selectedApplication) return Promise.resolve({success: false, message: 'No application selected'});

    const handleSubscription = (
      observable: Observable<WarningBaseModel<any>>,
      successMessage: string,
      errorMessage: string
    ): Promise<{success: boolean, message: string}> => {
      return new Promise((resolve) => {
        observable
          .pipe(
            finalize(() => {
              this.pdfModalRef?.hide();
            })
          )
          .subscribe({
            next: (response) => {
              if (response && response.result) {
                console.log(successMessage);
                resolve({success: true, message: successMessage});
              } else {
                console.warn('Response validation failed');
                const messages = response.messages || 'Response validation failed';
                const message = Array.isArray(messages) ? messages.join(', ') : messages;
                resolve({success: false, message: message});
              }
            },
            error: (error) => {
              const errorMsg = error?.message || errorMessage;
              console.error(errorMsg);
              resolve({success: false, message: errorMsg});
            },
          });
      });
    };


    if (this.cocTermLogic(selectedApplication)) {
      const signCoCRequest = this.grantApplication.signCoC(this.applicationId);
      return handleSubscription(
        signCoCRequest,
        `Successfully signed COC for task ID: ${this.applicationId}`,
        `Error signing COC for task ID: ${this.applicationId}`
      );
    }

    if (this.termLogic(selectedApplication)) {
      const termResult = this.grantApplication.signTerm(this.applicationId);
      return handleSubscription(
        termResult,
        `Successfully signed Term for task ID: ${this.applicationId}`,
        `Error signing Term for task ID: ${this.applicationId}`
      );
    }


    return Promise.resolve({success: false, message: 'No matching task type found'});
  }
}
